module.exports = __webpack_public_path__ + "static/media/lock-icon.657498b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/lock-icon.svg
// module id = 2886
// module chunks = 0